export { createLocalization } from './create-localization.js';
